import React from 'react'
import { RemotePopupUi } from './remote-popup-ui'
import { useTypography } from 'src/editor/shared/hooks/use-typography'

interface RemotePopupProps {
  children?: React.ReactNode
}

export const RemotePopup = ({ children }: RemotePopupProps) => {
  const {
    calculatedFontSize,
    calculatedFontFamily,
    calculatedFontWeight,
    calculatedFontStyle,
  } = useTypography()

  return (
    <RemotePopupUi
      fontFamily={calculatedFontFamily.desktop}
      fontSize={calculatedFontSize.desktop}
      mobileFontSize={calculatedFontSize.mobile}
    >
      {children}
    </RemotePopupUi>
  )
}
